import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import maskVideo from "../../../components/maskVideo";
import Swiper from 'swiper'
import './digitalizeCard.less'
export default {
    name: "digitalizeCard",
    data() {
        return {
            info: {
                btnTxt: '联系我们',
                btnType: 'href',
                btnHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                title1: '小精灵电子会员卡',
                info1: [
                    '打通微信原生电子会员卡,可以轻量快速的切入到门店,同时高效精准的抓住每一个消费',
                    '者,帮助商户快速的积累门店的私域流量,同时实现会员的精准标签,精准触达,精准营销。'
                ],
                title2: '会员卡的进阶之路',
                info2Pc: '看看会员卡的晋级之路,了解电子会员的必要性',
                info2Wap: '看看会员卡的晋级之路<br/>了解电子会员的必要性',
                pic2: 'img/digitalizeCard/pic2.png',
                title3: '更多电子会员卡能力',
                title4: '赶紧领取一张电子会员卡<br/>体验一下吧！',
                info4: '联拓富新零售门店',
                pic4: 'img/digitalizeCard/pic3.jpg',
                title5: '他们都在使用小精灵电子会员卡'
            },
            core: {
                titlePc: '小精灵电子会员卡的核心亮点',
                titleWap: '小精灵电子会员卡<br/>的核心亮点',
                pic: 'img/digitalizeCard/pic1.png',
                info: [
                    {
                        title: '一键开卡',
                        txt: '打通微信底层数据,自动拉取用户开卡数据,一键开卡,简便的体验可以让开卡量快速提升。',
                        pic: 'img/digitalizeCard/core1.png'
                    },
                    {
                        title: '支付码即会员码',
                        txt: '以支付为入口,支付自动开卡,开卡自动送券,支付自送识别会员,自动核销。',
                        pic: 'img/digitalizeCard/core2.png'
                    },
                    {
                        title: '有效全量触达',
                        txt: '通过微信服务通知和模版消息，让您随时都可以免费的、100%有效的触达会员，节约短信成本同时提高效率。',
                        pic: 'img/digitalizeCard/core3.png'
                    },
                    {
                        title: '精准营销',
                        txt: '后台根据会员的消费数据可以做各种纬度的标签,支持自由筛选,您可以根据标签所分层的人群进行精准的营销。',
                        pic: 'img/digitalizeCard/core4.png'
                    }
                ]
            },
            introduce: [
                {
                    title: '便捷、高效、有温度的用户体验',
                    txt: [
                      '从一键开卡开始,到会员的精准分类标签、微信有效触达、推荐裂变、各种趣味的互动营销、在线储值、',
                      '等级权益、在线商城/外卖消费、生日节日准时关怀...一张会员卡一个付款码全搞定。带来极致的用户体验!'
                    ],
                    pic: 'img/digitalizeCard/introduce1.png',
                    block: '',
                    info: [
                        {
                            title: '高效的开卡体验',
                            info: '支付即会员,一键开卡,避免排队等待,避免实体卡携带,避免补卡等尴尬问题。'
                        },
                        {
                            title: '快捷便利的消费体验',
                            info: '消费自动满减,消费自动积分,自动识别会员等级后自动享受折扣和优惠权益,在线即可储值,储值线上线下通用,极为便捷。'
                        },
                        {
                            title: '有温度的品牌感知',
                            info: '会员日、生日或者节日商家可以自动发券,微信服务通知100%看到门店的活动和消息,长期未消费还有问候和优惠等,品牌好感度快速提升。'
                        },
                        {
                            title: '有趣味的互动和体验',
                            info: '电子DM海报、推荐裂变、消费返现、幸运摇一摇、开心刮刮乐...营销玩法创意有趣,体验更棒!'
                        }
                    ]
                },
                {
                    title: '高效、精准、AI全自动的商户营销能力',
                    txt: [
                        '全自动闭环运营的营销SaaS服务,节约实体卡成本,提高服务员人效,有效提高品',
                        '牌好感度和活动参与率。轻实施,轻运营,让门店业绩倍增的营销机器人。'
                    ],
                    pic: 'img/digitalizeCard/introduce2.jpg',
                    block: 'swap',
                    info: [
                        {
                            title: '自动拉新',
                            info: '支付即会员,自动拉取用户微信底层数据,一键开卡,3秒拉新。'
                        },
                        {
                            title: '自动派券、自动核销',
                            info: '消费自动派券,满减自动派券,活动自动派券,节日自动派券…用户出示付款码自动核销。'
                        },
                        {
                            title: '自动深化客户关系',
                            info: '消费自动升级,付费自动升级,自动标签会员,自动识别会员身份和权益,自动拉动用户复购,培养忠诚会员。'
                        },
                        {
                            title: '自动沉睡唤醒',
                            info: '自动标签10天.15天.30天.60天…未到店消费的顾客,自动发券,自动唤醒客户到店消费。'
                        },
                        {
                            title: '自动裂变拉新',
                            info: '推荐自动发券,推荐储值自动分销,员工拓客分销,让门店客流不在难。'
                        },
                        {
                            title: '自动价值报告',
                            info: '每天一早9点自动发送价值报告,经营状况一手掌握,数据情况实时了解,运营策略及时调整。'
                        }
                    ]
                }
            ],
            tool: [
                {
                    title: '储值营销',
                    info: '设定储值档次，会员在线即可直接选择储值，设定赠送余额，储值即可显示数据资产余额，储值关联会员晋级和权益效果更佳，设置员工分销，增长显著！',
                    icon: 'tool1',
                    videoHref: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/05-储值营销-配音.mp4',
                    linkTxt: '了解更多',
                },
                {
                    title: '付费卡',
                    info: '强力锁定客户消费的必备武器，圈出你的忠诚客户！对于用户来说“钱在哪，心就在哪”，所以愿意为你的会员权益付费的用户，一定是你的“高净值客户”',
                    icon: 'tool2',
                    videoHref: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/11-付费卡-配音.mp4',
                    linkTxt: '了解更多',
                },
                {
                    title: '计次卡',
                    info: '次卡、周卡、月卡、季卡、年卡，泛娱乐行业必备能力！可以通过卡券商城、在线商城、企业微信等多种渠道售卖，关联员工售卖拓客分销能力，切实有效的提高门店售卡收入！',
                    icon: 'tool3',
                    videoHref: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/03-计次卡-配音.mp4',
                    linkTxt: '了解更多',
                },
                {
                    title: '小额储值',
                    info: '又可称为智能储值，降低储值门槛锁定复购，根据消费额度设置充值赠送余额，沉淀资金的同时，更能锁定消费，拉动复购，是多场景锁客神器！',
                    icon: 'tool4',
                    videoHref: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/06-小额储值-配音.mp4',
                    linkTxt: '了解更多',
                },
                {
                    title: '生日关怀',
                    info: '对用户的生日关怀，是提升用户好感度的利器！在顾客生日时可以设置提前发券，预约消费的形式增强用户的触达与体验，刺激客户到店消费，做更懂用户的商家！',
                    icon: 'tool5',
                    videoHref: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/10-生日关怀-配音.mp4',
                    linkTxt: '了解更多',
                },
                {
                    title: '沉默唤醒',
                    info: '唤醒沉默会员到店消费，清楚知道15天、30天、60天...未到店的顾客，根据会员标签定向激活，定向发券，节省营销成本！',
                    icon: 'tool6',
                    videoHref: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/13-沉默唤醒-配音.mp4',
                    linkTxt: '了解更多',
                },
                {
                    title: '节日营销',
                    info: '会员日是门店促销的大日子，也是顾客对品牌的记忆点。会员日提前/当天的真正活动触达，可以极大的提高活动活跃度，促进用户到店消费！',
                    icon: 'tool7',
                    videoHref: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/14-会员日节日营销-配音.mp4',
                    linkTxt: '了解更多',
                },
                {
                    title: '更多能力',
                    info: '构建是商户私域流量，建立商户数据资产，打造数字化门店！AI营销，让业绩增长更轻松！',
                    icon: 'tool7',
                    videoHref: '',
                    linkHref: 'digitalizeOverview',
                    linkTxt: '了解更多',
                }
            ],
            rollList: [
                {
                    src: "/img/digitalizeCard/roll1.png",
                    size: 4,
                    info: "【PART 10】酒吧，广州",
                },
                {
                    src: "/img/digitalizeCard/roll2.png",
                    size: 2,
                    info: "【长春藤】西餐，山东",
                },
                {
                    src: "/img/digitalizeCard/roll3.png",
                    size: 3,
                    info: "【面包新语】烘焙，全国连锁",
                },
                {
                    src: "/img/digitalizeCard/roll4.png",
                    size: 4,
                    info: "【凤姐小吃】小吃，昆明",
                },
                {
                    src: "/img/digitalizeCard/roll5.png",
                    size: 2,
                    info: "【怡家超市】零售，河北",
                }
            ]
        }
    },
    components: {
        skeleton,
        vueSeamlessScroll,
        maskVideo
    },
    mounted(){
        this.$nextTick( () => {
            new Swiper ('.swiper-pc', {
                // 如果需要滚动条
                // scrollbar: '.swiper-scrollbar',
                //如果需要自动切换海报
                // autoplay: {
                //   delay: 1000,//时间 毫秒
                //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
                // },
                slidesPerView: 2.3,
                spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            })
            new Swiper ('.swiper-wap', {
                // 如果需要滚动条
                // scrollbar: '.swiper-scrollbar',
                //如果需要自动切换海报
                // autoplay: {
                //   delay: 1000,//时间 毫秒
                //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
                // },
                slidesPerView: 1,
                spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            })
        })
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    }
}
